<script lang="ts">
    import InputWrapper from './InputWrapper.svelte';

    export let label: string;
    export let customClass: string = '';
    export let inline: boolean = false;
</script>

<InputWrapper label={label} inline={inline} customClass={customClass}>
    <span
        class="form-control-plaintext"
    >
        <slot></slot>
    </span>
</InputWrapper>